import { BreadcrumbSpec } from "@impero-com/common/componentTypes/breadcrumb";
import { useTranslation } from "@impero-com/common/utils/i18n";

import { WebRoute } from "../../routes";
import { useNewMenu } from "../navigation/useNewMenu";

import { controlEntitiesListUrl } from "./urlUtils";

export function useEntitiesBreadCrumbs(): BreadcrumbSpec["breadCrumbs"] {
    const { t } = useTranslation();
    const newMenu = useNewMenu();

    const entities = {
        label: t("EntityDefinition_Title"),
        url: controlEntitiesListUrl,
    };

    return newMenu
        ? [{ label: t("Navigation_Settings"), url: WebRoute.PROFILE }, entities]
        : [entities];
}
